import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_attendanceProjectList = async (page, limit, filters = {}) => {
    const params = new URLSearchParams(Object.entries(filters).filter(([, value]) => value));
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/projects/${page}/${limit}${params.toString() ? `?${params}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_attendanceSubmit = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_attendanceDetails = async (projectId, attendanceDate, { includePrevious = false } = {}) => {
    const query = includePrevious ? '?includePrevious=true' : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/${projectId}/${attendanceDate}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_attendanceUpdate = async (projectId, attendanceDate, model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/${projectId}/${attendanceDate}`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => res.data);
}

export const v3_delete_attendance = async (projectId, attendanceDate) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/${projectId}/${attendanceDate}`;
    return customAxios.delete(url, getAuthHeader()).then((res) => res.data);
}

export const v3_userMonthlyAttendance = async (projectId, month, year, userId, filters = {}) => {
    const params = new URLSearchParams(Object.entries(filters).filter(([, value]) => value));
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/user-monthly/${projectId}/${month}/${year}/${userId}${params.toString() ? `?${params}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_myMonthlyAttendance = async (month, year) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/my/${month}/${year}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_cofirmMonthlyAttendance = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/confirm`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_projectMonthlyAttendance = async (projectId, month, year, filters = {}) => {
    const params = new URLSearchParams(Object.entries(filters).filter(([, value]) => value));
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/monthly/${projectId}/${month}/${year}${params.toString() ? `?${params}` : ''}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const v3_projectMonthlyAttendanceStatus = async (projectId, month, year) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/status/${projectId}/${month}/${year}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}






export const v3_projectMonthlyAttendanceVerify = async (projectId, month, year) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/attendance/verify/${projectId}/${month}/${year}`;
    return customAxios.patch(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


